<template>
    <div>
        <b-nav-item-dropdown
            data-top-right-id="user-profile"
            id="nav-item-profile"
            v-if="currentActor"
            @show="profileClick"
            no-caret
            right
        >
            <!-- Using button-content slot -->
            <template slot="button-content">
                <ProfilePicture :currentActor="currentActor" />
            </template>

            <li class="actor">
                <div class="d-flex align-items-center">
                    <ProfilePicture class="mr-2" :currentActor="currentActor" />
                    <div class="d-flex flex-column">
                        <span class="name">
                            {{ currentActor.firstname }}
                            {{ currentActor.lastname.charAt(0).toUpperCase() }}
                        </span>
                        <span class="email">
                            {{ currentActor.email }}
                        </span>
                    </div>
                </div>
            </li>

            <b-dropdown-divider />
            <b-dropdown-item
                v-b-modal.lockDeviceModal
                data-top-profile-id="lock-screen"
            >
                <i
                    v-b-modal.lockDeviceModal
                    class="fas fa-lock"
                    style="margin-right: 5px;"
                ></i>
                Lock Screen
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item
                data-top-profile-id="my-profile"
                :to="'/settings/users/view/' + currentActor.encoded_id"
            >
                <i class="fas fa-user" style="margin-right: 5px;"></i>
                My Profile
            </b-dropdown-item>
            <b-dropdown-item
                v-if="isNotifcationFeatureEnabled"
                data-top-profile-id="notification-settings"
                :to="
                    '/settings/staff/profile/' +
                    currentActor.encoded_id +
                    '/notifications'
                "
            >
                <i class="fas fa-bell" style="margin-right: 5px;"></i>
                Notification Settings
            </b-dropdown-item>
            <b-dropdown-item
                v-if="$root.timesheet.clock_in"
                data-top-profile-id="clock-in"
                @click.stop="clockIn()"
            >
                <i class="fas fa-clock" style="margin-right: 5px;"></i>
                Clock In
            </b-dropdown-item>
            <b-dropdown-item
                v-if="$root.timesheet.clock_out"
                data-top-profile-id="clock-out"
                @click.stop="clockOut()"
            >
                <i class="fas fa-clock" style="margin-right: 5px;"></i>
                Clock Out
            </b-dropdown-item>
            <b-dropdown-item
                @click.stop="changePassword()"
                data-top-profile-id="change-password"
            >
                <i class="fas fa-key" style="margin-right: 5px;"></i>
                Change Password
            </b-dropdown-item>
            <b-dropdown-item
                :link-classes="'google-translate'"
                data-top-profile-id="google-translate"
            >
                <div id="google_translate_element" @click.stop.prevent></div>
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item
                :href="env.APPS + 'index.php/welcome/logout'"
                data-top-profile-id="logout"
            >
                <i class="fas fa-sign-out-alt" style="margin-right: 5px;"></i>
                Log Out
            </b-dropdown-item>
        </b-nav-item-dropdown>
        <b-container fluid>
            <changePassword ref="changePasswordWindow" />
        </b-container>
        <b-container fluid>
            <switchUser ref="switchUserWindow" />
        </b-container>
        <b-container fluid>
            <clockOut ref="clockOutWindow" />
        </b-container>
        <b-container fluid>
            <clockIn ref="clockInWindow" />
        </b-container>
    </div>
</template>
<style lang="scss" scoped>
[link-classes="google-translate"] {
    &.dropdown-item:hover,
    &.dropdown-item:focus {
        color: inherit;
        text-decoration: none;
        background: white;
    }
}
.actor {
    padding: 0.25rem 1.2rem;
    color: inherit;

    span {
        margin: 0;
        display: block;
    }
    .name {
        font-weight: bold;
    }
    .email {
        font-weight: normal;
        font-size: 0.9em;
    }
}
</style>
<script>
/* global google */
import ChangePassword from "./profile/change-password.vue";
import SwitchUser from "./profile/switch-user.vue";
import ClockOut from "./profile/clock-out.vue";
import ClockIn from "./profile/clock-in.vue";
import FeaturesEnabledMixin from "@/mixins/features-enabled";
import ProfilePicture from "./nav-item-profile-picture.vue";

export default {
    components: {
        ChangePassword,
        SwitchUser,
        ClockOut,
        ClockIn,
        ProfilePicture
    },
    mixins: [FeaturesEnabledMixin],
    props: ["currentActor"],
    created() {
        this._getSetting().then(() => {
            if (
                this._isExtensionEnabled("TIME_CLOCK") &&
                !this.$route.path.includes("tv/")
            ) {
                this.clockInCheck();
            }
            this.googleTranslateElementInit();
        });
    },
    mounted() {},
    methods: {
        profileClick() {
            this.googleTranslateElementInit();
        },
        googleTranslateElementInit() {
            new google.translate.TranslateElement(
                {
                    pageLanguage: "en",
                    layout:
                        google.translate.TranslateElement.InlineLayout.SIMPLE
                },
                "google_translate_element"
            );
        },
        changePassword() {
            this.$refs.changePasswordWindow.open();
        },
        switchUser() {
            this.$refs.switchUserWindow.open();
        },
        clockOut() {
            this.$refs.clockOutWindow.open();
        },
        clockIn() {
            //todo
            this.$refs.clockInWindow.open();
        },
        clockInCheck() {
            let storage_key =
                this.$root.setting.business_id +
                "_" +
                this.$root.currentActor.id +
                "_time_clock_key";

            if (localStorage.getItem(storage_key) === null) {
                // -- run check
                $.post(
                    this.env.APPS + "business/time_clock/clock_in_check"
                ).then(data => {
                    if (data.time_clock_popup) {
                        this.clockIn();
                    }

                    if (data.time_clock_key_value) {
                        localStorage.setItem(
                            storage_key,
                            JSON.stringify(data.time_clock_key_value)
                        );
                    }
                });
            } else {
                let time_clock_key = JSON.parse(
                    localStorage.getItem(storage_key)
                );

                if (
                    time_clock_key.extension_enabled &&
                    !time_clock_key.active_time_clock &&
                    !time_clock_key.hide_notification
                ) {
                    this.clockIn();
                }
            }
        }
    }
};
</script>
<style scoped>
.photo {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-right: 10px;
    border: 1px solid #ccc;
}
</style>
